module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/2023/area-icon3-1ef41c0b89b3ac20d42f2d9777d2f827.svg&quot;;"